var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLdBrandMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.510742 3.3284V36.5985C0.510742 38.1897 1.79541 39.4744 3.38665 39.4744H36.6567C39.2115 39.4744 40.4961 36.3795 38.6859 34.5693L5.41585 1.29921C3.60563 -0.511013 0.510742 0.773658 0.510742 3.3284Z",
    fill: "#4BABB3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0146 0.452515C16.4233 0.452515 15.1387 1.73719 15.1387 3.32843V36.6131C15.1387 38.2043 16.4233 39.489 18.0146 39.489C29.8978 39.489 39.5328 30.7591 39.5328 19.9854C39.5328 9.18244 29.8978 0.452515 18.0146 0.452515Z",
    fill: "#EE6338"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4744 31.3576L15.1387 11.0219V36.5985C15.1387 38.1897 16.4233 39.4744 18.0146 39.4744C25.1971 39.4744 31.562 36.2627 35.4744 31.3576Z",
    fill: "#F5B53F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdBrandMark);
export default __webpack_public_path__ + "static/media/ld-brand-mark.cfd0b3fb68af3f00dbe0659791e8a038.svg";
export { ForwardRef as ReactComponent };